module.exports = __webpack_public_path__ + "img/2024_ShortSleeve.2da4689b.jpg";